import { useQuery } from '@apollo/client';
import {
  CardPage,
  DateTimeFormatter,
  DisabledTag,
  SkeletonLoading,
  NoDataCard,
  useIsAuthorisedHook,
  EmptyTabState,
  getCurrentUserHook,
  AppContext,
  BackgroundIcon,
  getDownloadURL,
  ImagePreviewModal
} from '@nile/components';
import { GET_NOTE_LIST, GET_TASK_LIST } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { TaskProgressHolder } from '@nile/projects/src/Components/Elements';
import { GET_PROJECT } from '@nile/projects/src/Graphql';
import { Avatar, Heading, Page } from '@superops/ui-design-system';
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { renderTime } from '@nile/projects/src/Utils';
import { FormattedMessage } from 'react-intl';
import { ChatFeed } from 'react-bell-chat';
import { NoteBubble } from '@nile/mangifera/src/Components/Chat';
import { SVGIcon } from '@superops/super-icons';
import { sortBy } from 'lodash';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const MilestoneIconWrapper = styled.div`
  opacity: 0.6;
  margin-right: 10px;
`;

const EmptyStateHolder = styled.div.attrs({
  className: 'flex center jcenter'
})`
  height: calc(100% - 90px);
  overflow: auto;
`;

const CardPageProject = styled(CardPage)`
  .Polaris-Page {
    min-width: 550px;
  }
`;

const DetailsWrapper = styled.div`
  .header-section {
  }
  .notes-container {
    margin-left: -20px;

    .react-bell-chat__chat-panel {
      height: 100%;
    }

    .bubble {
      width: 100% !important;
    }
  }
  .status {
    padding: 4px 14px;
    background: #f0f0f6;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
  }
  .header-content-container {
    padding-top: 5px;
  }
  .more-details-label {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
  }
  .more-details-value {
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.8);
    width: 100%;
    max-width: calc(100% - 30px);
  }

  .milestone-section {
    margin-top: 70px;
  }
  .milestone-card {
    padding: 20px;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .milestone-name {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.8);
  }
  .task-details-container {
    width: 70%;
    margin: 10px;
    padding: 20px 0px;

    border-bottom: 1px solid #f3f3f3;
  }
  .task-title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }
  .no-data-container {
    margin-top: 20%;
  }
  .header-details-item {
    margin-left: -3px;
  }
`;

const TaskData = (props) => {
  const { item } = props;
  return (
    <>
      <div ley={item.taskId} className="task-details-container">
        <div className="flex mb-10">
          <label className="task-title">{item.title}</label>
          <div className="status flex center ml-20">{item?.status}</div>
        </div>
        <div className="mt-30 flex">
          <div className="fx actr w30">
            <div className="mr-10">
              <SVGIcon name="TechnicianGroup" color="#323232" />
            </div>
            {item.techGroup ? (
              <div>{item.techGroup?.name || 'NA'}</div>
            ) : (
              <DisabledTag>
                <FormattedMessage id="project.details.task.NA" />
              </DisabledTag>
            )}
          </div>
          <div className="fx actr w30">
            <div className="mr-10">
              <Avatar customer name="technician" size="small" />
            </div>
            {item.technician ? (
              `${item.technician.name}`
            ) : (
              <DisabledTag>
                <FormattedMessage id="project.details.task.NA" />
              </DisabledTag>
            )}
          </div>
          <div className="fx actr w30">
            <div className="mr-10">
              <SVGIcon name="EstimatedTime" color="#323232" />
            </div>
            {renderTime(item.estimatedTime) || (
              <DisabledTag>
                <FormattedMessage id="project.details.task.NA" />
              </DisabledTag>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
function ProjectDetailsClientContainer({ match, module, id }) {
  const { pagename } = match.params;
  const { accountType } = useContext(AppContext);
  const [projectData, setProjectData] = useState([{}]);
  const [taskData, setTasks] = useState([]);
  const [otherTask, setOtherTask] = useState([]);
  const [otherTaskTypes, setOtherTaskTypes] = useState(null);

  const isItProduct = useCheckIsItProduct();

  useEffect(() => {
    setOtherTask(taskData?.filter((task) => task?.milestone === null));
  }, [taskData]);

  const getTaskByType = (type) => {
    return otherTask.filter((task) => task.status === type);
  };

  useEffect(() => {
    const otherTaskByType = {
      planned: getTaskByType('Planned'),
      completed: [...getTaskByType('Completed'), ...getTaskByType('Cancelled')],
      progress: getTaskByType('In Progress'),
      blocked: getTaskByType('Blocked')
    };
    setOtherTaskTypes(otherTaskByType);
  }, [otherTask]);

  const { loading, error, data } = useQuery(GET_PROJECT, {
    variables: { projectId: id, isItProduct },
    fetchPolicy: 'cache-and-network',
    skip: !id,
    onCompleted({ getProject }) {
      setProjectData(getProject);
    }
  });

  const { loading: taskLoader } = useQuery(GET_TASK_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      module: 'PROJECT',
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'project.projectId',
              operator: 'is',
              value: id
            }
          ]
        },
        sort: [
          {
            attribute: 'taskOrder',
            order: 'ASC',
            emptyAtLast: true
          }
        ]
      }
    },
    onCompleted({ getTasks }) {
      setTasks(getTasks?.tasks || []);
    }
  });

  const {
    data: projectNotes,
    loading: projectNotesLoading,
    error: projectNotesError
  } = useQuery(GET_NOTE_LIST, {
    fetchPolicy: 'network-only',
    skip: useIsAuthorisedHook('comments.add'),
    variables: {
      input: {
        workItem: {
          workId: id,
          module: 'PROJECT'
        }
      }
    }
  });

  return (
    <CardPageProject
      className="full-height p20 flex g20"
      contentHeight="0px"
      contentPadding="10px 40px 20px"
      height="100px"
    >
      <div
        className={`project-details-wrapper ${
          projectNotes?.getNoteList.length ? 'w60' : 'w100'
        }`}
      >
        <Page variant="primary" fullWidth contentHeight="20px">
          {loading || taskLoader ? (
            <SkeletonLoading hideStepNav hideSecondaryHeader />
          ) : (
            <DetailsWrapper>
              <div className="header-section flex">
                <div className="logo-container mr30">
                  <SVGIcon name="ProjectFilled" size="xxl" />
                </div>
                <div className="header-content-container full-width">
                  <div className="flex">
                    <Heading element="h1">{projectData?.title}</Heading>
                    <div className="status flex center ml-20">
                      {projectData?.status}
                    </div>
                  </div>
                  <div className="mt-20 flex full-width">
                    <div className="w30">
                      <label className="more-details-label">
                        <FormattedMessage id="app.client.portal.project.detail.site" />
                      </label>
                      <div
                        className="flex aend header-details-item"
                        title={projectData?.site?.name}
                      >
                        <SVGIcon name="Site" size="md" />
                        <div className="more-details-value ellipsis ml-10 mt-10">
                          {projectData?.site?.name}
                        </div>
                      </div>
                    </div>
                    <div className="w30">
                      <label className="more-details-label">
                        <FormattedMessage id="app.client.portal.project.owner" />
                      </label>
                      <div
                        className="flex aend"
                        title={projectData?.owner?.name}
                      >
                        <Avatar customer size="small" />
                        <div className="more-details-value ellipsis ml-10 mt-10">
                          {projectData?.owner?.name}
                        </div>
                      </div>
                    </div>
                    <div className="w30">
                      <label className="more-details-label">
                        <FormattedMessage id="app.client.portal.project.due.date" />
                      </label>
                      <div className="flex aend">
                        <SVGIcon name="DatePicker" size="md" color="#323232" />
                        <div className="more-details-value ml-10 mt-10">
                          {projectData?.dueDate ? (
                            <DateTimeFormatter
                              type="dateTime"
                              date={projectData?.dueDate}
                            />
                          ) : (
                            'NA'
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="milestone-section full-height">
                {/* No DATA SHOULD BE VISIBLE ONLY IF NO MILESTONE AND NO OTHER TASK IS PRESENT */}
                {!projectData?.milestones?.length && !otherTask.length && (
                  <>
                    <div className="flex center jcenter full-height no-data-container">
                      <NoDataCard
                        imageURL={`url(${`${envConfig.imageRoot}svg/not-found.svg`})`}
                        description={
                          <FormattedMessage id="app.client.portal.no.data.found" />
                        }
                      />
                    </div>
                  </>
                )}

                {/* MILESTONE DATA  */}
                {sortBy(projectData?.milestones, 'milestoneOrder').map(
                  (item, index) => {
                    const taskFilteredData = taskData?.filter(
                      (taskItem) =>
                        taskItem?.milestone?.milestoneId === item.milestoneId
                    );
                    return (
                      <div
                        key={item.milestoneId}
                        className="milestone-card mb-20"
                      >
                        <div className="flex center mb-20">
                          <MilestoneIconWrapper>
                            <SVGIcon
                              name="Milestone"
                              size="lg"
                              color="#323232"
                            />
                          </MilestoneIconWrapper>
                          <label className="milestone-name">{item?.name}</label>
                        </div>
                        <TaskProgressHolder
                          completed={item?.completedTasks}
                          total={item?.totalTasks}
                          overdue={item?.overdueTasks}
                          open={item?.plannedTasks}
                          progress={item?.inProgressTasks}
                          blocked={item?.blockedTasks}
                        />
                        {taskFilteredData?.map((task, index) => {
                          return <TaskData item={task} />;
                        })}
                      </div>
                    );
                  }
                )}

                {/* OTHER TASK DATA */}
                {otherTask.length > 0 && (
                  <div className="milestone-card mb-20">
                    <div className="flex center mb-20">
                      <SVGIcon
                        name="Tasks"
                        width="24px"
                        height="24px"
                        color="#848484"
                      />
                      <label className="milestone-name ml-10">
                        <FormattedMessage id="project.details.otherTasks.othertasks" />
                      </label>
                    </div>
                    <TaskProgressHolder
                      completed={otherTaskTypes?.completed.length || 0}
                      total={otherTask?.length}
                      open={otherTaskTypes?.planned.length || 0}
                      progress={otherTaskTypes?.progress.length || 0}
                      blocked={otherTaskTypes.blocked.length || 0}
                    />
                    {otherTask.map((item, i) => {
                      return <TaskData item={item} />;
                    })}
                  </div>
                )}
              </div>
              <ImagePreviewModal />
            </DetailsWrapper>
          )}
        </Page>
      </div>
      {!(loading || projectNotesLoading) && projectNotes?.getNoteList.length ? (
        <div
          className={`project-notes-wrapper ${
            projectNotes?.getNoteList.length ? 'w40' : ''
          }`}
        >
          <Page variant="primary" fullWidth contentHeight="20px">
            {loading || projectNotesLoading ? (
              <SkeletonLoading hideStepNav hideSecondaryHeader />
            ) : (
              <DetailsWrapper>
                <div className="header-section flex">
                  <div className="header-content-container full-width">
                    <div className="flex">
                      <Heading element="h1">
                        <FormattedMessage id="common.attribute.note" />
                      </Heading>
                    </div>
                  </div>
                </div>
                <div className="fhp fw notes-container">
                  <NotesListContainer
                    notesData={projectNotes?.getNoteList || []}
                    workId={id}
                  />
                </div>
              </DetailsWrapper>
            )}
          </Page>
        </div>
      ) : null}
    </CardPageProject>
  );
}

function NotesListContainer({ notesData, workId }) {
  const user = getCurrentUserHook();
  const authors = [];
  const workItem = { workId: workId, module: 'PROJECT' };
  const notes = notesData?.map((note) => {
    authors.push({
      name: `${note.addedBy.firstName}  ${note.addedBy.lastName}`
    });
    return {
      message: note.content,
      id: note.noteId,
      isSend: true,
      authorId: note.addedBy.userId || 'system',
      user: note.addedBy,
      messageType: 'note',
      attachments: note?.attachments,
      type: 'note',
      workId: workId,
      time: note?.addedOn,
      data: note
    };
  });

  const getAttachmentURL = (msg, item) => {
    const module = 'NOTE_ATTACHMENT';
    const details = {
      fileName: item?.fileName,
      note: {
        noteId: msg?.id,
        workItem: workItem
      }
    };
    const url = getDownloadURL({ module, details });
    return url;
  };

  return notes.length ? (
    <ChatFeed
      customChatBubble={(props) => (
        <NoteBubble
          {...props}
          disableOptions
          module="NOTE"
          details={{ workItem: workItem }}
          disableSpit
          getAttachmentURL={getAttachmentURL}
        />
      )}
      messages={notes}
      authors={authors}
      yourAuthorId={user?.userId}
    />
  ) : (
    <EmptyStateHolder>
      <EmptyTabState
        iconName="EmptyTabNotes"
        title="project.notes.emptyState.title"
        description="project.notes.emptyState.description"
      />
    </EmptyStateHolder>
  );
}

export default withRouter(ProjectDetailsClientContainer);
